module.exports = __webpack_public_path__ + "img/HD_FOUR_DATA.9a5e7877.png";